<template>
    <span>{{ date | ago }}</span>
</template>
<script>
    export default {
        props: ['date'],
        filters: {
            ago(date) {
                return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').fromNow();
            }
        }
    }
</script>